import { QueryParameterSchema } from './types';

export const agencyFilterQueryFilter: QueryParameterSchema<'agencyId'> = {
  getDefaultValue: () => [],
  getValue: ({ queryParameters }) => queryParameters.agencyId,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    agencyId: urlSearchParams.get('filter[agencyId]')?.split(',') || [],
  }),
  toUrlSearchParams: ({ value }) => ({ 'filter[agencyId]': value.join(',') }),
  toSearchQuery: ({ value }) => {
    if (value.length === 0) return {};
    return { 'filter[agencyId]': value };
  },
  getSummaryItems: ({
    value,
    staticProps: {
      referenceData: { agencies },
    },
  }) => {
    return value.map((agencyId) => ({
      filterKey: 'agencyId',
      key: `agency_${agencyId}_loading`,
      label: `${agencies[agencyId]?.name}`,
      value: agencyId,
    }));
  },
  removeParam: ({ value, removedValue }) => {
    return { agencyId: value.filter((item) => item !== removedValue) };
  },
};
